import CarCanvas from "../components/CarCanvas";
import Cars from "../components/Cars";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useContext, useEffect } from "react";
import { CarbonContext } from "../CarbonContext";
import { useNavigate } from "react-router-dom";
const Home = () => {
  const { token } = useContext(CarbonContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token.access_token) {
      navigate("/");
    }
  }, [token, navigate]);

  return (
    <>
      <Navbar />
      <CarCanvas />
      <Cars />
      <Footer />
    </>
  );
};

export default Home;
